<template>
  <b-modal
    id="modal-filter"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    scrollable
    title="過瀘"
    title-class="font-weight-bolder"
    body-class="common_modal modal_visible"
    hide-header
    hide-footer
    no-close-on-backdrop
    size="sm"
    hide-header-close
  >
    <feather-icon
      @click="hide"
      style="position: absolute; right: 20px; top: -40px"
      size="18"
      icon="XIcon"
    />
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="項目："
              label-for="filter_project_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_project_id"
                v-model="update.filter_project_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="projectOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇項目"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="狀態："
              label-for="filter_aduit_status_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_aduit_status_id"
                v-model="update.filter_aduit_status_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="aduitStatusOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇狀態"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="支付方式："
              label-for="filter_payment_method_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_payment_method_id"
                v-model="update.filter_payment_method_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="paymentMethodStatusOptions"
                :filter="paymentMethodSearch"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇支付方式"
              >
              </v-select>
            </b-form-group>
          </b-col>

        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <!-- type="reset" -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="update = {}"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            提交
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCardBody,
    BCard,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-filter");
    },
    paymentMethodSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    onSubmit() {
      this.$emit("update:filter_project_id", this.update.filter_project_id);
      this.$emit(
        "update:filter_aduit_status_id",
        this.update.filter_aduit_status_id
      );
      this.$emit(
        "update:filter_payment_method_id",
        this.update.filter_payment_method_id
      );
      this.hide();
    },
  },
  props: {
    projectOptions: {
      type: Array,
      required: true,
    },
    aduitStatusOptions: {
      type: Array,
      required: true,
    },
    paymentMethodStatusOptions: {
      type: Array,
      required: true,
    },
    filter_project_id: {
    },
    filter_aduit_status_id: {
    },
    filter_payment_method_id: {
    },
  },
  data() {
    return {
      loading: false,
      update: {
        filter_project_id:null,
        filter_aduit_status_id:null,
        filter_payment_method_id:null,
      },
     
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
